import { render, staticRenderFns } from "./ByTypeSystems.vue?vue&type=template&id=a410dcd4&scoped=true"
import script from "./ByTypeSystems.vue?vue&type=script&lang=js"
export * from "./ByTypeSystems.vue?vue&type=script&lang=js"
import style0 from "./ByTypeSystems.vue?vue&type=style&index=0&id=a410dcd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a410dcd4",
  null
  
)

export default component.exports